/**
 * Criteo Event Listeners
 *
 * Uses the unified event system (pmw:pixel:*) with firing decisions.
 *
 * @see https://help.criteo.com/kb/guide/en/introduction-to-the-criteo-onetag-8fjCDwCENw
 */

(function (pmw, undefined) {

	/**
	 * Load pixel on consent
	 */
	pmw.bus.on("pmw:load-pixels", function () {
		if (
			pmwDataLayer?.pixels?.criteo?.account_id &&
			!pmwDataLayer?.pixels?.criteo?.loaded &&
			pmw.consent.canPixelBeFired("marketing", "Criteo")
		) {
			pmw.loadCriteoPixel();
		}
	});

	/**
	 * View Item event
	 *
	 * Fires on product detail pages.
	 */
	pmw.bus.on("pmw:pixel:view-item", (payload) => {
		if (!pmwDataLayer?.pixels?.criteo?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "criteo")) return;

		try {
			const criteoData = payload.pixels?.criteo;
			if (!criteoData) return;

			pmw.criteoTrackEvent(criteoData);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * View Item List event
	 *
	 * The Pixel Manager fires one view_item_list event per product that
	 * becomes visible on a listing page, while Criteo expects a single
	 * viewList event with the product IDs of the page. The IDs are
	 * collected and sent as one viewList event shortly after the last
	 * product came into view.
	 */
	let criteoViewListItems   = [];
	let criteoViewListTimeout = null;

	pmw.bus.on("pmw:pixel:view-item-list", (payload) => {
		if (!pmwDataLayer?.pixels?.criteo?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "criteo")) return;

		try {
			const criteoData = payload.pixels?.criteo;
			if (!criteoData?.item?.length) return;

			criteoViewListItems = criteoViewListItems.concat(criteoData.item);

			if (criteoViewListTimeout) clearTimeout(criteoViewListTimeout);

			criteoViewListTimeout = setTimeout(() => {
				// Deduplicate and cap the list. Criteo recommends the top
				// products of the listing, three IDs being the minimum.
				const items = Array.from(new Set(criteoViewListItems)).slice(0, 10);

				criteoViewListItems   = [];
				criteoViewListTimeout = null;

				if (!items.length) return;

				pmw.criteoTrackEvent({event: "viewList", item: items});
			}, 500);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * Add to Cart event
	 *
	 * Fires when a product is added to the cart.
	 */
	pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {
		if (!pmwDataLayer?.pixels?.criteo?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "criteo")) return;

		try {
			const criteoData = payload.pixels?.criteo;
			if (!criteoData) return;

			pmw.criteoTrackEvent(criteoData);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * View Cart event
	 *
	 * Fires on the cart page.
	 */
	pmw.bus.on("pmw:pixel:view-cart", (payload) => {
		if (!pmwDataLayer?.pixels?.criteo?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "criteo")) return;

		try {
			const criteoData = payload.pixels?.criteo;
			if (!criteoData) return;

			pmw.criteoTrackEvent(criteoData);
		} catch (e) {
			console.error(e);
		}
	});

	/**
	 * Purchase / Order Received event
	 *
	 * Fires when a purchase is completed and the order received page is viewed.
	 */
	pmw.bus.on("pmw:pixel:purchase", (payload) => {
		if (!pmwDataLayer?.pixels?.criteo?.loaded) return;
		if (!pmw.shouldFireBrowserPixel(payload, "criteo")) return;

		try {
			const criteoData = payload.pixels?.criteo;
			if (!criteoData) return;

			pmw.criteoTrackEvent(criteoData);
		} catch (e) {
			console.error(e);
		}
	});

}(window.pmw = window.pmw || {}));
